export const nwccEnvs = {
    dev: "https://nwcc-apps-dev-aws.dev.sc.egov.usda.gov",
    devTest: "https://nwcc-apps-dev-test-aws.dev.sc.egov.usda.gov",
    diag: "https://nwcc-apps-diag-aws.dev.sc.egov.usda.gov",
    load: "https://nwcc-apps-load-aws.cert.sc.egov.usda.gov",
    test: "https://nwcc-apps-test-aws.cert.sc.egov.usda.gov",
    uat: "https://nwcc-apps-uat-aws.cert.sc.egov.usda.gov",
    train: "https://nwcc-appstrain.sc.egov.usda.gov",
    prod: "https://nwcc-apps.sc.egov.usda.gov",
};

export const wcisEnvs = {
    dev: "https://wcc-dev-aws.dev.sc.egov.usda.gov",
    devTest: "https://wcc-dev-test-aws.dev.sc.egov.usda.gov",
    diag: "https://wcc-diag-aws.dev.sc.egov.usda.gov",
    load: "https://wcc-load-aws.cert.sc.egov.usda.gov",
    test: "https://wcc-test-aws.cert.sc.egov.usda.gov",
    uat: "https://wcc-uat-aws.cert.sc.egov.usda.gov",
    train: "https://wcctrain.sc.egov.usda.gov",
    prod: "https://wcc.sc.egov.usda.gov",
};

export const restApiPath = "/awdbRestApi/services/v1";
export const awsApiPath = "/aws-api";
export const fcstVerPath = "/fcst-ver";
export const wssDashPath = "/wss-dash";
export const sntlRegrPath = "/sntl-regr";

export let wcisDomain = "";
export let restApiDomain = restApiPath;

export let nwccDomain = "";
export let awsApiDomain = awsApiPath;
export let wssDashDomain = wssDashPath;
export let fcstVerDomain = fcstVerPath;
export let sntlRegrDomain = sntlRegrPath;

let domainArray = window.location.hostname.split(".");
if (window.location.hostname == "127.0.0.1") {
    domainArray[0] = "127.0.0.1";
}

determineDomains();

export function convertDomainToWCIS() {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    return `${protocol}//${hostname.replace("nwcc-apps", "wcc")}`;
}

export function convertDomainToNWCC() {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    return `${protocol}//${hostname.replace("wcc", "nwcc-apps")}`;
}

export function isLocal(override) {
    if (!override) {
        if (
            ["test", "development"].includes(import.meta?.env?.MODE?.toLowerCase()) ||
            ["localhost", "127.0.0.1"].includes(domainArray[0])
        ) {
            return true;
        }
    }
    return false;
}

export function determineDomains(projectOverride, nwccOverride, wcisOverride, isHosted = false) {
    if (isLocal(isHosted)) {
        const envObj = import.meta.env;
        if (envObj?.MODE === "test" || envObj?.MODE === "development") {
            setLocalDomains(projectOverride, nwccOverride, wcisOverride);
            logDomains();
        }
    } else {
        setDomains(domainArray[0]);
    }
}

export function setDomains(override) {
    const subDomain = override || domainArray[0];
    if (subDomain.startsWith("nwcc-apps")) {
        // nwcc apps deployment
        wcisDomain = convertDomainToWCIS();
        restApiDomain = `${wcisDomain}${restApiPath}`;
    } else {
        // wcis deployment
        nwccDomain = convertDomainToNWCC();
        awsApiDomain = `${nwccDomain}${awsApiPath}`;
    }
}

export function setLocalDomains(projectOverride, nwccOverride, wcisOverride) {
    nwccDomain = window.location.origin;
    wcisDomain = window.location.origin;
    const envObj = import.meta.env;
    const project = projectOverride || envObj?.VITE_PROJECT;
    if (project) {
        if (project.includes("nwcc")) {
            const wcisEnv = wcisOverride || envObj?.VITE_WCIS_ENV || "prod";
            wcisDomain = wcisEnvs[wcisEnv] ? wcisEnvs[wcisEnv] : window.location.origin;
            restApiDomain = `${wcisDomain}${restApiPath}`;

            const nwccEnv = nwccOverride || envObj?.VITE_NWCC_ENV || "prod";
            const useLocalNwccApps = nwccEnv.toLowerCase() === "local" || !Object.keys(nwccEnvs).includes(nwccEnv);
            let [protocol, port] = nwccDomain.split(`${domainArray[0]}:`);

            let awsApiPort = envObj?.VITE_AWS_API_PORT || `${Number(port) + 1}`;
            awsApiDomain = useLocalNwccApps
                ? `${protocol}${domainArray[0]}:${awsApiPort}`
                : `${nwccEnvs[nwccEnv]}${awsApiPath}`;

            let wssDashPort = envObj?.VITE_WSS_DASH_PORT || `${Number(port) + 2}`;
            wssDashDomain = useLocalNwccApps
                ? `${protocol}${domainArray[0]}:${wssDashPort}`
                : `${nwccEnvs[nwccEnv]}${wssDashPath}`;

            let fcstVerPort = envObj?.VITE_FCST_VER_PORT || `${Number(port) + 3}`;
            fcstVerDomain = useLocalNwccApps
                ? `${protocol}${domainArray[0]}:${fcstVerPort}`
                : `${nwccEnvs[nwccEnv]}${fcstVerPath}`;

            let sntlRegrPort = envObj?.VITE_SNTL_REGR_PORT || `${Number(port) + 4}`;
            sntlRegrDomain = useLocalNwccApps
                ? `${protocol}${domainArray[0]}:${sntlRegrPort}`
                : `${nwccEnvs[nwccEnv]}${sntlRegrPath}`;
        } else if (project.includes("wcis")) {
            const nwccEnv = nwccOverride || envObj?.VITE_NWCC_ENV || "prod";
            nwccDomain = nwccEnvs[nwccEnv] || nwccEnvs.prod;
        }
    }
}

export function logDomains() {
    wcisDomain && console.log(`Using ${wcisDomain} for wcis links`);
    restApiDomain && console.log(`Using ${restApiDomain} for rest-api links`);
    nwccDomain && console.log(`Using ${nwccDomain} for nwcc links`);
    awsApiDomain && console.log(`Using ${awsApiDomain} for aws-api links`);
    wssDashDomain && console.log(`Using ${wssDashDomain} for wss-dash links`);
    fcstVerDomain && console.log(`Using ${fcstVerDomain} for fcst-ver links`);
    sntlRegrDomain && console.log(`Using ${sntlRegrDomain} for sntl-regr links`);
}
